import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { ConfirmationPopup } from '@/components/ui/confirmation-popup'
import { TextArea } from '@/components/ui/text-area'
import { Typography } from '@/components/ui/typography'

import * as S from './ban-visitor-modal.styled'

interface BanVisitorModalProps {
  name: string
  type?: 'guest' | 'vendor' | 'visitor'
  onClose: () => void
  onConfirm: (reason: string) => Promise<void>
}

export const BanVisitorModal = ({
  name,
  type = 'visitor',
  onClose,
  onConfirm,
}: BanVisitorModalProps) => {
  const { t } = useTranslation(['visitors'])
  const [reason, setReason] = useState('')
  const [isError, setIsError] = useState(false)

  return (
    <ConfirmationPopup
      title={t('visitors:dashboard.banModal.title', { name })}
      variant="danger"
      confirmText={t('visitors:columns.ban')}
      autoClose={false}
      onClose={onClose}
      onConfirm={async () => {
        if (!reason.trim()) {
          setIsError(true)
          return
        }
        await onConfirm(reason.trim())
        onClose()
      }}
    >
      <S.Content>
        <Typography size="heading-medium">
          {t('visitors:confirm.banBody', { name, type })}
        </Typography>
        <TextArea
          label={t('visitors:columns.banReasonLabel')}
          placeholder={t('visitors:dashboard.banModal.reasonPlaceholder', { type })}
          value={reason}
          error={
            isError && !reason.trim() ? t('visitors:dashboard.banModal.reasonRequired') : undefined
          }
          onChange={(e) => {
            setReason(e.target.value)
            if (isError) setIsError(false)
          }}
        />
      </S.Content>
    </ConfirmationPopup>
  )
}
